module.exports = __webpack_public_path__ + "static/media/day-trade-for-living.51e2a209.jpeg";